export enum Weekday {
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
}

export function translateWeekday(weekday: Weekday, locale: string) {
  const dummyDate = new Date(2001, 0, weekday);
  return dummyDate.toLocaleDateString(locale, { weekday: "long" });
}
